import { optimizedAppearDataAttribute } from "./data-id";
export function getOptimisedAppearId(visualElement) {
    return visualElement.props[optimizedAppearDataAttribute];
}
//# sourceMappingURL=get-appear-id.js.map